const languageReducer = (state = "", action) => {
    switch(action.type) {
        case 'SET_LANGUAGE':
            state = action.payload;
            return state;
        default:
            return state;
    }
}

export default languageReducer;